<template>
  <div class="monitor-container container-view" ref="pageView">
    <!-- title -->
    <section class="title-section">
      <p class="titleInfo fl">{{ curTime }}</p>
      <!--<p class="titleText"></p>-->
    </section>
    <section class="main">
      <section class="chartPanel">
        <!--topLeft-->
        <div
          class="chartPanel-child topLeft"
          v-loading="topLeftLoading"
          element-loading-background="rgba(0, 0, 0, 0.7)"
        >
          <ul class="chartPanel-child-slide">
            <li
              v-for="(item, index) in topLeftTimelineData"
              :key="item"
              :class="{ active: index === topLeftTimelineActiveIndex }"
              @click="chartInstanceTimelineProgressChange('topLeft', index)"
            >
              {{ item }}
            </li>
          </ul>
          <div class="chartPanel-child-chartArea" ref="topLeftChartDOM"></div>
        </div>
        <!--topRight-->
        <div
          class="chartPanel-child topRight"
          v-loading="topRightLoading"
          element-loading-background="rgba(0, 0, 0, 0.7)"
        >
          <ul class="chartPanel-child-slide">
            <li
              v-for="(item, index) in topRightTimelineData"
              :key="item"
              :class="{ active: index === topRightTimelineActiveIndex }"
              @click="chartInstanceTimelineProgressChange('topRight', index)"
            >
              {{ item }}
            </li>
          </ul>
          <div class="chartPanel-child-chartArea" ref="topRightChartDOM"></div>
        </div>
        <!--centerMap-->
        <div
          class="chartPanel-child middleCenter"
          v-loading="mapLoading"
          element-loading-background="rgba(0, 0, 0, 0.7)"
        >
          <div class="chartPanel-child-chartArea" ref="mapChartDOM"></div>
        </div>
        <!--bottomLeft-->
        <div
          class="chartPanel-child bottomLeft"
          v-loading="bottomLeftLoading"
          element-loading-background="rgba(0, 0, 0, 0.7)"
        >
          <ul class="chartPanel-child-slide">
            <li
              v-for="(item, index) in bottomLeftTimelineData"
              :key="item"
              :class="{ active: index === bottomLeftTimelineActiveIndex }"
              @click="chartInstanceTimelineProgressChange('bottomLeft', index)"
            >
              {{ item }}
            </li>
          </ul>
          <div
            class="chartPanel-child-chartArea"
            ref="bottomLeftChartDOM"
          ></div>
        </div>
        <!--bottomCenter-->
        <section
          class="chartPanel-child bottomCenter"
          v-loading="bottomCenterLoading"
          element-loading-background="rgba(0, 0, 0, 0.7)"
        >
          <ul class="chartPanel-child-slide">
            <li
              v-for="(item, index) in bottomCenterTimelineData"
              :key="item"
              :class="{ active: index === bottomCenterTimelineActiveIndex }"
              @click="
                chartInstanceTimelineProgressChange('bottomCenter', index)
              "
            >
              {{ item }}
            </li>
          </ul>
          <div
            class="chartPanel-child-chartArea"
            ref="bottomCenterChartDOM"
          ></div>
        </section>
        <!--bottomRight-->
        <div
          class="chartPanel-child bottomRight"
          v-loading="bottomRightLoading"
          element-loading-background="rgba(0, 0, 0, 0.7)"
        >
          <ul class="chartPanel-child-slide">
            <li
              v-for="(item, index) in bottomRightTimelineData"
              :key="item"
              :class="{ active: index === bottomRightTimelineActiveIndex }"
              @click="chartInstanceTimelineProgressChange('bottomRight', index)"
            >
              {{ item }}
            </li>
          </ul>
          <div
            class="chartPanel-child-chartArea"
            ref="bottomRightChartDOM"
          ></div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
// plugin
import moment from "moment";
import Echarts from "echarts";
import { mapGetters, mapMutations } from "vuex";

// interface
import {
  FetchTopComparyRedOrder,
  FetchTopComparyBlackOrder,
  FetchAlarmLocation,
  FetchLast7DayAlarm,
  FetchAlarmByLocation,
  FetchAlarmByScenes
} from "@/api/board/alarm";

// mixins
import resizeListener from "_private/mixins/resizeListener";

// charts setting
import { handleMapData } from "./chartConfig.js";

export default {
  mixins: [resizeListener],
  data() {
    return {
      curTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      timeInterval: null, // 时间显示定时器
      resizeTimer: null, // resize事件节流timer
      clientWidth: document.documentElement.clientWidth, // 页面宽度
      clientHeight: document.documentElement.clientHeight, // 页面高度
      reloadDataTime: 1000 * 60 * 60, // 刷新数据时间间隔

      /************ topLeft ****************/
      topLeftChartInstance: null, // 左上角图表实例
      topLeftLoading: false, // 左上角数据正在加载
      topLeftChartData: {
        lastDateData: [],
        last7DateData: [],
        lastMouthData: []
      },
      topLeftTimelineData: ["昨日", "近7日", "近1月"],
      topLeftTimelineActiveIndex: 0,

      /*********** topRight ********************/
      topRightChartInstance: null, // 右上角图表实例
      topRightLoading: false, // 右上角数据正在加载
      topRightChartData: {
        lastDateData: [],
        last7DateData: [],
        lastMouthData: []
      },
      topRightTimelineData: ["昨日", "近7日", "近1月"],
      topRightTimelineActiveIndex: 0,

      /*********** bottomLeft ********************/
      bottomLeftChartInstance: null, // 左下角图表实例
      bottomLeftLoading: false, // 左下角数据正在加载
      bottomLeftChartData: {
        vehicleAlarmData: [],
        storageAlarmData: [],
        cupboardAlarmData: [],
        leadStorageAlarmData: [],
      },
      bottomLeftTimelineData: ["车辆","前置仓", "冷库", "冷柜"],
      bottomLeftTimelineActiveIndex: 0,

      /*********** bottomCenter ********************/
      bottomCenterChartInstance: null, // 左中部图表实例
      bottomCenterLoading: false, // 左中部数据正在加载
      bottomCenterChartData: {
        lastDateData: [],
        last7DateData: [],
        lastMouthData: []
      },
      bottomCenterTimelineData: ["昨日", "近7日", "近1月"],
      bottomCenterTimelineActiveIndex: 0,

      /*********** bottomRight ********************/
      bottomRightChartInstance: null, // 右下角图表实例
      bottomRightLoading: false, // 右下角数据正在加载
      bottomRightChartData: {
        lastDateData: {},
        last7DateData: {},
        lastMouthData: {}
      },
      bottomRightTimelineData: ["昨日", "近7日", "近1月"],
      bottomRightTimelineActiveIndex: 0,

      /************* centerMap ********************/
      fetchMapChartDataTimer: null,
      mapChartInstance: null, // 地图图表实例
      mapChartData: {
        freezerList: [],
        storageList: [],
        vehicleList: [],
        leadStorageList: []
      },
      mapLoading: false,
      mapChartHighlightTimer: null
    };
  },

  created() {
    !this.isFullScreen && this.updateFullScreen();
  },

  mounted() {
    this.initCenterMap(); // 初始化中间地图geo数据，获取业务数据
  },

  beforeDestroy() {
    clearInterval(this.timeInterval); // 清除定时器
    clearInterval(this.mapChartHighlightTimer);
  },

  computed: {
    ...mapGetters(["isFullScreen"])
  },

  methods: {
    ...mapMutations(["updateFullScreen"]),

    // 设置左上角钟表定时器
    setCLockTimeInterval() {
      clearInterval(this.timeInterval);
      // 设置定时器，每个1秒获取一次时间信息
      this.timeInterval = setInterval(() => {
        this.curTime = moment().format("YYYY-MM-DD HH:mm:ss");
      }, 1000);
    },

    // 监控浏览器及元素变化
    resizeListener() {
      clearTimeout(this.resizeTimer);

      this.resizeTimer = setTimeout(() => {
        this.$nextTick(() => {
          this.clientWidth = document.documentElement.clientWidth;
          this.clientHeight = document.documentElement.clientHeight;

          this.topLeftChartInstance && this.topLeftChartInstance.resize();
          this.topRightChartInstance && this.topRightChartInstance.resize();
          this.bottomLeftChartInstance && this.bottomLeftChartInstance.resize();
          this.bottomCenterChartInstance &&
            this.bottomCenterChartInstance.resize();
          this.bottomRightChartInstance &&
            this.bottomRightChartInstance.resize();
          this.mapChartInstance && this.mapChartInstance.resize();
        });
      }, 300);
    },

    /************************** topLeft ************************************/
    // 获取企业红榜TOP10数据
    fetchTopLeftChartData() {
      this.topLeftLoading = true;
      FetchTopComparyRedOrder()
        .then(({ code, result, message }) => {
          if (code === 1 && result) {
            // result = {
            //   lastDateData: [
            //     { alarmCount: 14, companyName: "入驻企业1" },
            //     { alarmCount: 23, companyName: "入驻企业3" },
            //     { alarmCount: 35, companyName: "入驻企业5" },
            //     { alarmCount: 41, companyName: "入驻企业7" },
            //     { alarmCount: 57, companyName: "入驻企业9" },
            //     { alarmCount: 65, companyName: "入驻企业11" },
            //     { alarmCount: 79, companyName: "入驻企业13" },
            //     { alarmCount: 85, companyName: "入驻企业15" },
            //     { alarmCount: 93, companyName: "入驻企业17" },
            //     { alarmCount: 99, companyName: "入驻企业19" }
            //   ],
            //   last7DateData: [
            //     { alarmCount: 94, companyName: "入驻企业1" },
            //     { alarmCount: 145, companyName: "入驻企业3" },
            //     { alarmCount: 254, companyName: "入驻企业5" },
            //     { alarmCount: 387, companyName: "入驻企业7" },
            //     { alarmCount: 465, companyName: "入驻企业9" },
            //     { alarmCount: 521, companyName: "入驻企业11" },
            //     { alarmCount: 688, companyName: "入驻企业13" },
            //     { alarmCount: 797, companyName: "入驻企业15" },
            //     { alarmCount: 856, companyName: "入驻企业17" },
            //     { alarmCount: 946, companyName: "入驻企业19" }
            //   ],
            //   lastMouthData: [
            //     { alarmCount: 999, companyName: "入驻企业1" },
            //     { alarmCount: 1054, companyName: "入驻企业3" },
            //     { alarmCount: 2987, companyName: "入驻企业5" },
            //     { alarmCount: 3876, companyName: "入驻企业7" },
            //     { alarmCount: 4201, companyName: "入驻企业9" },
            //     { alarmCount: 5881, companyName: "入驻企业11" },
            //     { alarmCount: 6391, companyName: "入驻企业13" },
            //     { alarmCount: 7289, companyName: "入驻企业15" },
            //     { alarmCount: 8548, companyName: "入驻企业17" },
            //     { alarmCount: 9653, companyName: "入驻企业19" }
            //   ]
            // };
            this.topLeftChartData = result;
          } else {
            this.errorMessage(message || "获取企业红榜TOP10数据失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取企业红榜TOP10数据失败");
        })
        .finally(() => {
          this.topLeftLoading = false;
          this.initTopLeftChart();
        });
    },
    // 初始化左上角图表
    initTopLeftChart() {
      if (this.topLeftChartInstance) {
        this.topLeftChartInstance.clear();
      } else {
        this.topLeftChartInstance = Echarts.init(this.$refs.topLeftChartDOM);
        this.topLeftChartInstance.on("timelinechanged", ({ currentIndex }) => {
          this.topLeftTimelineActiveIndex = currentIndex;
        });
      }
      const options = [
        {
          dataset: {
            source: this.topLeftChartData.lastDateData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "昨日"
          }
        },
        {
          dataset: {
            source: this.topLeftChartData.last7DateData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "近7日"
          }
        },
        {
          dataset: {
            source: this.topLeftChartData.lastMouthData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "近1月"
          }
        }
      ];

      this.topLeftChartInstance.setOption({
        baseOption: {
          title: {
            text: "企业红榜 {style1|TOP10}",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(16),
              lineHeight: this.calcYDirectionSizeByPercent(30),
              rich: {
                style1: {
                  color: "#ffea94"
                }
              }
            },
            padding: [
              this.calcYDirectionSizeByPercent(2),
              this.calcXDirectionSizeByPercent(0),
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          grid: {
            bottom: this.calcYDirectionSizeByPercent(30),
            right: this.calcXDirectionSizeByPercent(50),
            top: this.calcYDirectionSizeByPercent(56),
            left: this.calcXDirectionSizeByPercent(62)
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 4,
            data: this.topLeftTimelineData
          },
          xAxis: {
            show: false
          },
          yAxis: {
            type: "category",
            min: 0,
            inverse: true,
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              inside: true,
              margin: -this.calcXDirectionSizeByPercent(50),
              formatter: (name, index) => {
                let result = "";
                if (name.length > 6) {
                  result = name.slice(0, 6) + "...";
                } else {
                  result = name;
                }
                return `{index|${index + 1}}{name|${result}}`;
              },
              rich: {
                index: {
                  width: this.calcXDirectionSizeByPercent(60),
                  fontSize: this.calcXDirectionSizeByPercent(32),
                  align: "right",
                  fontWeight: "bold",
                  fontStyle: "italic",
                  color: "rgba(255, 87, 34, .8)"
                },
                name: {
                  fontSize: this.calcXDirectionSizeByPercent(14),
                  color: "rgba(255, 255, 255, 0.4)"
                }
              }
            }
          },
          series: {
            type: "bar",
            label: {
              show: true,
              position: "right",
              distance: this.calcXDirectionSizeByPercent(7),
              color: "#fff",
              fontSize: this.calcXDirectionSizeByPercent(14)
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255, 87, 34, 0)" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(255, 87, 34, .8)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              },
              barBorderRadius: [
                0,
                this.calcYDirectionSizeByPercent(28) / 2,
                this.calcYDirectionSizeByPercent(28) / 2,
                0
              ]
            },
            barWidth: this.calcYDirectionSizeByPercent(30),
            barMinHeight: this.calcXDirectionSizeByPercent(110)
          }
        },
        options
      });
    },

    /************************** topRight ************************************/
    // 获取企业黑榜TOP10数据
    fetchTopRightData() {
      this.topRightLoading = true;
      FetchTopComparyBlackOrder()
        .then(({ code, result, message }) => {
          if (code === 1 && result) {
            // result = {
            //   lastDateData: [
            //     { alarmCount: 95, companyName: "入驻企业2" },
            //     { alarmCount: 89, companyName: "入驻企业4" },
            //     { alarmCount: 73, companyName: "入驻企业6" },
            //     { alarmCount: 64, companyName: "入驻企业8" },
            //     { alarmCount: 55, companyName: "入驻企业10" },
            //     { alarmCount: 47, companyName: "入驻企业12" },
            //     { alarmCount: 39, companyName: "入驻企业14" },
            //     { alarmCount: 20, companyName: "入驻企业16" },
            //     { alarmCount: 14, companyName: "入驻企业18" },
            //     { alarmCount: 6, companyName: "入驻企业20" }
            //   ],
            //   last7DateData: [
            //     { alarmCount: 976, companyName: "入驻企业2" },
            //     { alarmCount: 854, companyName: "入驻企业4" },
            //     { alarmCount: 798, companyName: "入驻企业6" },
            //     { alarmCount: 610, companyName: "入驻企业8" },
            //     { alarmCount: 523, companyName: "入驻企业10" },
            //     { alarmCount: 456, companyName: "入驻企业12" },
            //     { alarmCount: 355, companyName: "入驻企业14" },
            //     { alarmCount: 265, companyName: "入驻企业16" },
            //     { alarmCount: 198, companyName: "入驻企业18" },
            //     { alarmCount: 56, companyName: "入驻企业20" }
            //   ],
            //   lastMouthData: [
            //     { alarmCount: 9754, companyName: "入驻企业2" },
            //     { alarmCount: 8451, companyName: "入驻企业4" },
            //     { alarmCount: 7941, companyName: "入驻企业6" },
            //     { alarmCount: 6545, companyName: "入驻企业8" },
            //     { alarmCount: 5987, companyName: "入驻企业10" },
            //     { alarmCount: 4349, companyName: "入驻企业12" },
            //     { alarmCount: 3876, companyName: "入驻企业14" },
            //     { alarmCount: 2711, companyName: "入驻企业16" },
            //     { alarmCount: 1673, companyName: "入驻企业18" },
            //     { alarmCount: 1001, companyName: "入驻企业20" }
            //   ]
            // };
            this.topRightChartData = result;
          } else {
            this.errorMessage(message || "获取企业黑榜TOP10数据失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取企业黑榜TOP10数据失败");
        })
        .finally(() => {
          this.topRightLoading = false;
          this.initTopRightChart();
        });
    },
    // 初始化右上角图表
    initTopRightChart() {
      if (this.topRightChartInstance) {
        this.topRightChartInstance.clear();
      } else {
        this.topRightChartInstance = Echarts.init(this.$refs.topRightChartDOM);
        this.topRightChartInstance.on("timelinechanged", ({ currentIndex }) => {
          this.topRightTimelineActiveIndex = currentIndex;
        });
      }
      const options = [
        {
          dataset: {
            source: this.topRightChartData.lastDateData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "昨日"
          }
        },
        {
          dataset: {
            source: this.topRightChartData.last7DateData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "近7日"
          }
        },
        {
          dataset: {
            source: this.topRightChartData.lastMouthData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "近1月"
          }
        }
      ];

      this.topRightChartInstance.setOption({
        baseOption: {
          title: {
            text: "企业黑榜 {style1|TOP10}",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(16),
              lineHeight: this.calcYDirectionSizeByPercent(30),
              rich: {
                style1: {
                  color: "#ffea94"
                }
              }
            },
            padding: [
              this.calcYDirectionSizeByPercent(2),
              this.calcXDirectionSizeByPercent(0),
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          grid: {
            bottom: this.calcYDirectionSizeByPercent(30),
            right: this.calcXDirectionSizeByPercent(50),
            top: this.calcYDirectionSizeByPercent(56),
            left: this.calcXDirectionSizeByPercent(62)
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 4,
            data: this.topLeftTimelineData
          },
          xAxis: {
            show: false
          },
          yAxis: {
            type: "category",
            min: 0,
            inverse: true,
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              inside: true,
              margin: -this.calcXDirectionSizeByPercent(50),
              formatter: (name, index) => {
                let result = "";
                if (name.length > 6) {
                  result = name.slice(0, 6) + "...";
                } else {
                  result = name;
                }
                return `{index|${index + 1}}{name|${result}}`;
              },
              rich: {
                index: {
                  width: this.calcXDirectionSizeByPercent(60),
                  fontSize: this.calcXDirectionSizeByPercent(32),
                  align: "right",
                  fontWeight: "bold",
                  fontStyle: "italic",
                  color: "rgba(63, 238, 212, 0.6)"
                },
                name: {
                  fontSize: this.calcXDirectionSizeByPercent(14),
                  color: "rgba(255, 255, 255, 0.4)"
                }
              }
            }
          },
          series: {
            type: "bar",
            label: {
              show: true,
              position: "right",
              distance: this.calcXDirectionSizeByPercent(7),
              color: "#fff",
              fontSize: this.calcXDirectionSizeByPercent(14)
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(63, 238, 212, 0)" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(63, 238, 212, 1)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              },
              barBorderRadius: [
                0,
                this.calcYDirectionSizeByPercent(28) / 2,
                this.calcYDirectionSizeByPercent(28) / 2,
                0
              ]
            },
            barMinHeight: this.calcXDirectionSizeByPercent(110),
            barWidth: this.calcYDirectionSizeByPercent(28)
          }
        },
        options
      });
    },

    /************************** centerMap ************************************/
    // 初始化中间地图geo数据，获取业务数据
    async initCenterMap() {
      // 获取地区内部/外部轮廓地理位置信息
      let geoDirName = this.$GLOBAL_CONFIG.displayBoard.alarmStatic.map
        .geoDirName; // geo文件件
      let geoPromises = [
        import(`@/assets/geo/${geoDirName}/inline.json`),
        import(`@/assets/geo/${geoDirName}/outline.json`)
      ];
      let [inlineGeo, outlineGeo] = await Promise.all(geoPromises);

      // 初始化地图
      Echarts.registerMap("inlineMap", inlineGeo);
      Echarts.registerMap("outlineMap", outlineGeo);

      // 获取地图业务数据
      this.fetchTopLeftChartData();
      this.fetchTopRightData();
      this.fetchCenterMapData();
      this.fetchBottomCenterData();
      this.fetchBottomLeftData();
      this.fetchBottomRightData();
      this.setCLockTimeInterval();
    },
    // 获取中部地图数据
    fetchCenterMapData() {
      clearInterval(this.fetchMapChartDataTimer);
      const fetchDataFun = () => {
        this.mapLoading = true;
        FetchAlarmLocation()
          .then(({ code, result, message }) => {
            if (code === 1 && result) {
              // result = {
              //   freezerLonLatList: [
              //     {
              //       lat: 22.579614,
              //       lon: 114.057293,
              //       name: "河南众荣门店1",
              //       subsetName: "河南众荣冷柜1,河南众荣冷柜2,河南众荣冷柜3"
              //     }
              //   ],
              //   storageLonLatList: [
              //     {
              //       lat: 34.77,
              //       lon: 112.98,
              //       name: "测试冷冻库1"
              //     },
              //     {
              //       lat: 34.75,
              //       lon: 113.67,
              //       name: "测试冷冻库2"
              //     },
              //     {
              //       lat: 45.121,
              //       lon: 124.121231,
              //       name: "伊利仓库01"
              //     },
              //     {
              //       lat: 45.121,
              //       lon: 124.121231,
              //       name: "伊利仓库01"
              //     }
              //   ],
              //   vehicleLonLatList: [
              //     {
              //       lat: 34.778823,
              //       lon: 113.70328,
              //       name: "陕A12345"
              //     }
              //   ]
              // };
              this.mapChartData = {
                freezerList: handleMapData(result.freezerLonLatList || []),
                storageList: handleMapData(result.storageLonLatList || []),
                vehicleList: handleMapData(result.vehicleLonLatList || []),
                leadStorageList: handleMapData(result.leadStorageLonLatList || []),
              };
            } else {
              this.errorMessage(message || "获取地图数据失败");
            }
          })
          .catch(err => {
            console.log(err);
            this.errorMessage("获取地图数据失败");
          })
          .finally(() => {
            this.mapLoading = false;
            this.initMapChart();
          });
      };
      fetchDataFun();
      this.fetchMapChartDataTimer = setInterval(fetchDataFun, 1e3 * 60 * 3);
    },
    // 初始化中部地图
    initMapChart() {
      if (this.mapChartInstance) {
        this.mapChartInstance.clear();
      } else {
        this.mapChartInstance = Echarts.init(this.$refs.mapChartDOM);
      }
      const mapChartData = this.mapChartData;
      const option = {
        legend: {
          data: ["车辆","前置仓", "冷库", "冷柜",],
          textStyle: {
            color: "#7b89dc"
          },
          top: this.calcYDirectionSizeByPercent(40)
        },
        tooltip: {
          show: true
        },
        geo: [
          {
            name: "inlineMap",
            type: "map",
            map: "inlineMap",
            roam: false,
            zoom: 1,
            top: this.calcYDirectionSizeByPercent(74),
            right: "5%",
            bottom: "1%",
            left: "5%",
            tooltip: {
              show: false
            },
            label: {
              normal: {
                show: true,
                position: "inside", //显示位置
                offset: [0, 0], //偏移设置
                color: "#7b89dc",
                // formatter: "{b}", //圆环显示文字
                fontWeight: "lighter",
                fontSize: 12
              },
              emphasis: {
                color: "#ffffff",
                show: true
              }
            },
            itemStyle: {
              normal: {
                borderColor: "#3d59cd",
                borderWidth: 1,
                areaColor: "rgba(65, 82, 245, 0.2)",
                shadowColor: "rgba(51, 69, 255, 0.5)",
                // shadowColor: 'rgba(255, 255, 255, 1)',
                // shadowOffsetX: -2,
                // shadowOffsetY: 2,
                shadowBlur: 10
              },
              emphasis: {
                areaColor: "rgba(65, 82, 245, 0.5)"
                // borderWidth: 0
              }
            }
          },
          {
            map: "outlineMap",
            roam: false,
            zoom: 1,
            top: this.calcYDirectionSizeByPercent(74),
            right: "5%",
            bottom: "1%",
            left: "5%",
            label: {
              show: false,
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                borderColor: "#4a75ff",
                borderWidth: 5,
                areaColor: "rgba(65, 82, 245, 0)",
                shadowColor: "rgba(51, 69, 255, 1)",
                shadowBlur: 20
              },
              emphasis: {
                areaColor: "rgba(0, 0, 0, 0)"
              }
            },
            hoverAnimation: false,
            show: true
          }
        ],
        series: [
          {
            name: "车辆",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: false,
            itemStyle: {
              color: "#afa3f5",
              shadowBlur: 2,
              opacity: 0.3,
              shadowColor: "#ffffff"
            },
            emphasis: {
              itemStyle: {
                opacity: 1,
                shadowBlur: 7
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let result = "";
                result +=
                  '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                  params.color +
                  '"></span>';
                result += params.seriesName + "：" + params.name + "<br>";
                return result;
              }
            },
            data: mapChartData.vehicleList
          },
          {
            name: "前置仓",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: false,
            itemStyle: {
              color: "#e98f6c",
              shadowBlur: 2,
              opacity: 0.3,
              shadowColor: "#ffffff"
            },
            emphasis: {
              itemStyle: {
                opacity: 1,
                shadowBlur: 7
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let result = "";
                result +=
                  '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                  params.color +
                  '"></span>';
                result += params.seriesName + "：" + params.name + "<br>";
                return result;
              }
            },
            data: mapChartData.leadStorageList
          },
          {
            name: "冷库",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: false,
            itemStyle: {
              color: "#f1bb4c",
              shadowBlur: 2,
              opacity: 0.3,
              shadowColor: "#ffffff"
            },
            emphasis: {
              itemStyle: {
                opacity: 1,
                shadowBlur: 7
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let result = "";
                result +=
                  '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                  params.color +
                  '"></span>';
                result += params.seriesName + "：" + params.name + "<br>";
                return result;
              }
            },
            data: mapChartData.storageList
          },
          {
            name: "冷柜",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: false,
            itemStyle: {
              color: "#3feed4",
              shadowBlur: 2,
              opacity: 0.3,
              shadowColor: "#ffffff"
            },
            emphasis: {
              itemStyle: {
                opacity: 1,
                shadowBlur: 7
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let result = "";
                result +=
                  '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                  params.color +
                  '"></span>';
                if (params.data.subsetName) {
                  result += params.seriesName + "：" + params.name + "<br />";
                  result += params.data.subsetName;
                } else {
                  result += params.seriesName + "：" + params.name + "<br />";
                }
                return result;
              },
              extraCssText: "width:300px; white-space:pre-wrap" // 额外添加到浮层的css样式，用于换行。
            },
            data: mapChartData.freezerList
          }
        ]
      };

      this.mapChartInstance.setOption(option);

      clearInterval(this.mapChartHighlightTimer);
      let highlightIndex = 0;
      this.mapChartHighlightTimer = setInterval(() => {
        // 设置高亮
        this.mapChartInstance.dispatchAction({
          type: "highlight",
          seriesIndex: highlightIndex % 4
        });
        // 取消上一个高亮
        this.mapChartInstance.dispatchAction({
          type: "downplay",
          seriesIndex: (highlightIndex - 1) % 4
        });

        highlightIndex++;
      }, 1e3);
    },

    /************************** bottomLeft ************************************/
    // 获取车/前置仓/仓/柜近7日报警数量统计数据
    fetchBottomLeftData() {
      this.bottomLeftLoading = true;
      FetchLast7DayAlarm()
        .then(({ code, result, message }) => {
          if (code === 1 && result) {
            // result = {
            //   vehicleAlarmData: [
            //     { time: "9.1", count: 243 },
            //     { time: "9.4", count: 331 },
            //     { time: "9.7", count: 435 },
            //     { time: "9.10", count: 273 },
            //     { time: "9.13", count: 288 },
            //     { time: "9.16", count: 326 },
            //     { time: "9.19", count: 251 }
            //   ],
            //   storageAlarmData: [
            //     { time: "9.1", count: 343 },
            //     { time: "9.4", count: 331 },
            //     { time: "9.7", count: 233 },
            //     { time: "9.10", count: 273 },
            //     { time: "9.13", count: 388 },
            //     { time: "9.16", count: 326 },
            //     { time: "9.19", count: 231 }
            //   ],
            //   cupboardAlarmData: [
            //     { time: "9.1", count: 245 },
            //     { time: "9.4", count: 251 },
            //     { time: "9.7", count: 255 },
            //     { time: "9.10", count: 275 },
            //     { time: "9.13", count: 288 },
            //     { time: "9.16", count: 126 },
            //     { time: "9.19", count: 251 }
            //   ]
            // };
            this.bottomLeftChartData = result;
          } else {
            this.errorMessage(
              message || "获取车/前置仓/库/柜近7日报警数量统计数据失败"
            );
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取车/前置仓/库/柜近7日报警数量统计数据失败");
        })
        .finally(() => {
          this.bottomLeftLoading = false;
          this.initBottomLeftChart();
        });
    },
    // 初始化底部左侧图表
    initBottomLeftChart() {
      if (this.bottomLeftChartInstance) {
        this.bottomLeftChartInstance.clear();
      } else {
        this.bottomLeftChartInstance = Echarts.init(
          this.$refs.bottomLeftChartDOM
        );
        this.bottomLeftChartInstance.on(
          "timelinechanged",
          ({ currentIndex }) => {
            this.bottomLeftTimelineActiveIndex = currentIndex;
          }
        );
      }

      const DATA_LENGTH = this.bottomLeftChartData.vehicleAlarmData.length || 0;
      const options = [
        {
          dataset: {
            source: this.bottomLeftChartData.vehicleAlarmData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "车辆",
            itemStyle: {
              color: item =>
                this.calcGradualChangeColor(
                  item.dataIndex,
                  DATA_LENGTH,
                  [175, 163, 245],
                  [105, 85, 255]
                )
            },
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#afa3f5" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#6955ff" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(104, 85, 255, 0.6)" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(104, 85, 255, 0)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        },
        {
          dataset: {
            source: this.bottomLeftChartData.leadStorageAlarmData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "前置仓",
            itemStyle: {
              color: item =>
                this.calcGradualChangeColor(
                  item.dataIndex,
                  DATA_LENGTH,
                  [243, 170, 141],
                  [243, 51, 0]
                )
            },
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#f3aa8d" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#f33300" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(243, 51, 0, 0.6)" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(243, 51, 0, 0)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        },
        {
          dataset: {
            source: this.bottomLeftChartData.storageAlarmData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "冷库",
            itemStyle: {
              color: item =>
                this.calcGradualChangeColor(
                  item.dataIndex,
                  DATA_LENGTH,
                  [241, 187, 75],
                  [215, 107, 21]
                )
            },
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#f1bb4b" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#d76b15" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(215, 107, 21, 0.6)" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(215, 107, 21, 0)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        },
        {
          dataset: {
            source: this.bottomLeftChartData.storeAlarmData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "冷柜",
            itemStyle: {
              color: item =>
                this.calcGradualChangeColor(
                  item.dataIndex,
                  DATA_LENGTH,
                  [63, 238, 212],
                  [1, 161, 76]
                )
            },
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#3eeed4" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#00a24c" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 161, 76, 0.6)" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 161, 76, 0)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        }
      ];
      this.bottomLeftChartInstance.setOption({
        baseOption: {
          title: {
            text: "车/前置仓/库/柜近7日报警数量统计",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(16),
              lineHeight: this.calcYDirectionSizeByPercent(30)
            },
            padding: [
              this.calcYDirectionSizeByPercent(2),
              this.calcXDirectionSizeByPercent(0),
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          grid: {
            top: this.calcYDirectionSizeByPercent(55),
            right: this.calcXDirectionSizeByPercent(20),
            bottom: this.calcYDirectionSizeByPercent(39),
            left: this.calcXDirectionSizeByPercent(40)
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 4,
            data: this.bottomLeftTimelineData
          },
          xAxis: {
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#7b89dc",
                opacity: 0.4
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(8),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          yAxis: {
            type: "value",
            min: 0,
            axisTick: {
              show: false
            },
            lineStyle: {
              color: "#7b89dc",
              opacity: 0.4
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(5),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          series: {
            type: "line",
            symbol: "circle",
            smooth: true,
            symbolSize: this.calcXDirectionSizeByPercent(6),
            label: {
              show: false
            },
            barWidth: this.calcYDirectionSizeByPercent(15)
          }
        },
        options
      });
    },

    /************************* bottomCenter ***********************************/
    // 获取各地区报警数量统计数据
    fetchBottomCenterData() {
      this.bottomCenterLoading = true;
      FetchAlarmByLocation()
        .then(({ code, result, message }) => {
          if (code === 1 && result) {
            // result = {
            //   lastDateData: [
            //     { count: 12, countyName: "中原区" },
            //     { count: 24, countyName: "二七区" },
            //     { count: 35, countyName: "金水区" },
            //     { count: 27, countyName: "惠济区" },
            //     { count: 13, countyName: "管城区" },
            //     { count: 6, countyName: "上街区" },
            //     { count: 45, countyName: "荥阳市" },
            //     { count: 36, countyName: "巩义市" },
            //     { count: 44, countyName: "登封市" },
            //     { count: 39, countyName: "新密市" },
            //     { count: 24, countyName: "新郑市" },
            //     { count: 26, countyName: "中牟县" }
            //   ],
            //   last7DateData: [
            //     { count: 101, countyName: "中原区" },
            //     { count: 273, countyName: "二七区" },
            //     { count: 121, countyName: "金水区" },
            //     { count: 452, countyName: "惠济区" },
            //     { count: 321, countyName: "管城区" },
            //     { count: 543, countyName: "上街区" },
            //     { count: 111, countyName: "荥阳市" },
            //     { count: 342, countyName: "巩义市" },
            //     { count: 435, countyName: "登封市" },
            //     { count: 387, countyName: "新密市" },
            //     { count: 456, countyName: "新郑市" },
            //     { count: 354, countyName: "中牟县" }
            //   ],
            //   lastMouthData: [
            //     { count: 1296, countyName: "中原区" },
            //     { count: 1675, countyName: "二七区" },
            //     { count: 1374, countyName: "金水区" },
            //     { count: 1254, countyName: "惠济区" },
            //     { count: 1431, countyName: "管城区" },
            //     { count: 1521, countyName: "上街区" },
            //     { count: 1245, countyName: "荥阳市" },
            //     { count: 1654, countyName: "巩义市" },
            //     { count: 1353, countyName: "登封市" },
            //     { count: 1266, countyName: "新密市" },
            //     { count: 1351, countyName: "新郑市" },
            //     { count: 1522, countyName: "中牟县" }
            //   ]
            // };
            this.bottomCenterChartData = result;
          } else {
            this.errorMessage(message || "获取各地区报警数量统计数据失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取各地区报警数量统计数据失败");
        })
        .finally(() => {
          this.bottomCenterLoading = false;
          this.initBottomCenterChart();
        });
    },
    // 初始化底部中间图表
    initBottomCenterChart() {
      if (this.bottomCenterChartInstance) {
        this.bottomCenterChartInstance.clear();
      } else {
        this.bottomCenterChartInstance = Echarts.init(
          this.$refs.bottomCenterChartDOM
        );
        this.bottomCenterChartInstance.on(
          "timelinechanged",
          ({ currentIndex }) => {
            this.bottomCenterTimelineActiveIndex = currentIndex;
          }
        );
      }
      const options = [
        {
          dataset: {
            source: this.bottomCenterChartData.lastDateData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "昨日"
          }
        },
        {
          dataset: {
            source: this.bottomCenterChartData.last7DateData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "近7日"
          }
        },
        {
          dataset: {
            source: this.bottomCenterChartData.lastMouthData,
            dimensions: ["name", "countNum"]
          },
          series: {
            name: "近1月"
          }
        }
      ];
      this.bottomCenterChartInstance.setOption({
        baseOption: {
          title: {
            text: "地区报警数量统计",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(16),
              lineHeight: this.calcYDirectionSizeByPercent(30)
            },
            padding: [
              this.calcYDirectionSizeByPercent(2),
              this.calcXDirectionSizeByPercent(0),
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          grid: {
            top: this.calcYDirectionSizeByPercent(55),
            right: this.calcXDirectionSizeByPercent(20),
            bottom: this.calcYDirectionSizeByPercent(39),
            left: this.calcXDirectionSizeByPercent(40)
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 4,
            data: this.bottomCenterTimelineData
          },
          xAxis: {
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#7b89dc",
                opacity: 0.4
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(8),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          yAxis: {
            type: "value",
            min: 0,
            axisTick: {
              show: false
            },
            lineStyle: {
              color: "#7b89dc",
              opacity: 0.4
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(5),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          series: {
            type: "bar",
            label: {
              show: false,
              position: "top",
              distance: this.calcXDirectionSizeByPercent(7),
              color: "#fff",
              fontSize: this.calcXDirectionSizeByPercent(14)
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 1,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#4249ff" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#008aff" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              },
              barBorderRadius: [
                this.calcYDirectionSizeByPercent(4),
                this.calcYDirectionSizeByPercent(4),
                0,
                0
              ]
            },
            barWidth: this.calcYDirectionSizeByPercent(15)
          }
        },
        options
      });
    },

    /************************** bottomRight ************************************/
    // 获取各区县在线率及温度合格率数据
    fetchBottomRightData() {
      this.bottomRightLoading = true;
      FetchAlarmByScenes()
        .then(({ code, result, message }) => {
          if (code === 1 && result) {
            // result = {
            //   lastDateData: {
            //     vehicleAlarmCount: 24,
            //     storageAlarmCount: 37,
            //     storeAlarmCount: 43
            //   },
            //   last7DateData: {
            //     vehicleAlarmCount: 145,
            //     storageAlarmCount: 201,
            //     storeAlarmCount: 341
            //   },
            //   lastMouthData: {
            //     vehicleAlarmCount: 675,
            //     storageAlarmCount: 824,
            //     storeAlarmCount: 546
            //   }
            // };
            this.bottomRightChartData = result;
          } else {
            this.errorMessage(
              message || "获取各区县在线率及温度合格率数据失败"
            );
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取各区县在线率及温度合格率数据失败");
        })
        .finally(() => {
          this.bottomRightLoading = false;
          this.initBottomRightChart();
        });
    },
    // 初始化底部右侧图表
    initBottomRightChart() {
      if (this.bottomRightChartInstance) {
        this.bottomRightChartInstance.clear();
      } else {
        this.bottomRightChartInstance = Echarts.init(
          this.$refs.bottomRightChartDOM
        );
        this.bottomRightChartInstance.on(
          "timelinechanged",
          ({ currentIndex }) => {
            this.bottomRightTimelineActiveIndex = currentIndex;
          }
        );
      }

      const options = [
        {
          series: {
            name: "昨日",
            data: [
              this.bottomRightChartData.lastDateData.vehicleAlarmCount,
              this.bottomRightChartData.lastDateData.leadStorageAlarmCount,
              this.bottomRightChartData.lastDateData.storageAlarmCount,
              this.bottomRightChartData.lastDateData.storeAlarmCount,
            ]
          }
        },
        {
          series: {
            name: "近7日",
            data: [
              this.bottomRightChartData.last7DateData.vehicleAlarmCount,
               this.bottomRightChartData.lastDateData.leadStorageAlarmCount,
              this.bottomRightChartData.last7DateData.storageAlarmCount,
              this.bottomRightChartData.last7DateData.storeAlarmCount
            ]
          }
        },
        {
          series: {
            name: "近1月",
            data: [
              this.bottomRightChartData.lastMouthData.vehicleAlarmCount,
               this.bottomRightChartData.lastDateData.leadStorageAlarmCount,
              this.bottomRightChartData.lastMouthData.storageAlarmCount,
              this.bottomRightChartData.lastMouthData.storeAlarmCount
            ]
          }
        }
      ];
      this.bottomRightChartInstance.setOption({
        baseOption: {
          title: {
            text: "车/前置仓/库/柜报警数量统计",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(16),
              lineHeight: this.calcYDirectionSizeByPercent(30)
            },
            padding: [
              this.calcYDirectionSizeByPercent(2),
              this.calcXDirectionSizeByPercent(0),
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          grid: {
            top: this.calcYDirectionSizeByPercent(55),
            right: this.calcXDirectionSizeByPercent(20),
            bottom: this.calcYDirectionSizeByPercent(39),
            left: this.calcXDirectionSizeByPercent(40)
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 4,
            data: this.bottomCenterTimelineData
          },
          xAxis: {
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#7b89dc",
                opacity: 0.4
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(8),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            },
            data: ["车", "前置仓", "库", "柜"]
          },
          yAxis: {
            type: "value",
            min: 0,
            axisTick: {
              show: false
            },
            lineStyle: {
              color: "#7b89dc",
              opacity: 0.4
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(5),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          series: {
            type: "pictorialBar",
            symbol:
              "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
            label: {
              show: false,
              position: "top",
              distance: this.calcXDirectionSizeByPercent(7),
              color: "#fff",
              fontSize: this.calcXDirectionSizeByPercent(14)
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(175, 163, 245, 1)" // 0% 处的颜色
                  },
                  {
                    offset: 0.3,
                    color: "rgba(175, 163, 245, 1)" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(175, 163, 245, 0.25)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              },
              barBorderRadius: [
                this.calcYDirectionSizeByPercent(4),
                this.calcYDirectionSizeByPercent(4),
                0,
                0
              ]
            },
            barWidth: this.calcXDirectionSizeByPercent(173)
          }
        },
        options
      });
    },

    // 自动轮播timeline进度更改
    chartInstanceTimelineProgressChange(type, index) {
      let chartInstance = null;
      switch (type) {
        case "topLeft":
          this.topLeftTimelineActiveIndex = index;
          chartInstance = this.topLeftChartInstance;
          break;
        case "topRight":
          this.topRightTimelineActiveIndex = index;
          chartInstance = this.topRightChartInstance;
          break;
        case "bottomLeft":
          this.bottomLeftTimelineActiveIndex = index;
          chartInstance = this.bottomLeftChartInstance;
          break;
        case "bottomCenter":
          this.bottomCenterTimelineActiveIndex = index;
          chartInstance = this.bottomCenterChartInstance;
          break;
        case "bottomRight":
          this.bottomRightTimelineActiveIndex = index;
          chartInstance = this.bottomRightChartInstance;
          break;
      }

      chartInstance &&
        chartInstance.dispatchAction({
          type: "timelineChange",
          currentIndex: index
        });
    },

    // 计算渐变颜色
    calcGradualChangeColor(index, length, startColor, endColor) {
      const rColor =
        startColor[0] + ((endColor[0] - startColor[0]) / length) * index;
      const gColor =
        startColor[1] + ((endColor[1] - startColor[1]) / length) * index;
      const bColor =
        startColor[2] + ((endColor[2] - startColor[2]) / length) * index;

      return `rgb(${rColor}, ${gColor}, ${bColor})`;
    },

    // 计算横向尺寸百分比
    calcXDirectionSizeByPercent(size) {
      return (size / 1920) * this.clientWidth;
    },

    // 计算纵向向尺寸百分比
    calcYDirectionSizeByPercent(size) {
      return (size / 1080) * this.clientHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "LEDNumber";
  src: url(~@/assets/ledFont/LEDNum.eot); /***兼容ie9***/
  src: url(~@/assets/ledFont/LEDNum.eot?#iefix) format("embedded-opentype"),
    /***兼容ie6-ie8***/ url("~@/assets/ledFont/LEDNum.woff") format("woff"),
    local("LEDNum"), url("~@/assets/ledFont/LEDNum.woff"); /***默认使用本地的***/
}

$layout-width: 1920px;
$layout-height: 1080px;

.monitor-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #09121b;
  background-image: url("~@/assets/images/alarmBoard/bigScreenBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  /*标题*/
  .title-section {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    z-index: 2;
    box-sizing: border-box;
    width: 100%;
    height: 0.83rem;
    padding-top: 0.14rem;
    background-image: url("~@/assets/images/alarmBoard/bigScreenTitleBg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;

    p {
      margin: 0;
    }

    .titleInfo {
      font-family: "LEDNumber";
      color: #3f83ff;
      font-size: 0.22rem;
      word-spacing: 1em;
      margin-left: 0.35rem;
    }

    .titleText {
      width: 2.6rem;
      height: 0.3rem;
      margin: 0 auto;
      background-image: url("~@/assets/images/alarmBoard/title_text.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
    }
  }

  .main {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    p {
      margin: 0;
    }

    .chartPanel {
      &-child {
        position: absolute;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &.topLeft {
          left: (10px / $layout-width) * 100%;
          top: (70px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (640px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/top_bg.png");
        }

        &.topRight {
          right: (10px / $layout-width) * 100%;
          top: (70px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (640px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/top_bg.png");
        }

        &.middleCenter {
          left: 0;
          right: 0;
          top: (70px / $layout-height) * 100%;
          margin: 0 auto;
          width: (936px / $layout-width) * 100%;
          height: (641px / $layout-height) * 100%;
        }

        &.bottomLeft {
          left: (10px / $layout-width) * 100%;
          bottom: (10px / $layout-height) * 100%;
          width: (572px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/bottom_bg.png");
        }

        &.bottomCenter {
          left: 0;
          right: 0;
          bottom: (10px / $layout-height) * 100%;
          margin: 0 auto;
          width: (675px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/bottom_bg.png");
        }

        &.bottomRight {
          right: (10px / $layout-width) * 100%;
          bottom: (10px / $layout-height) * 100%;
          width: (572px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/bottom_bg.png");
        }

        &-slide {
          position: absolute;
          top: 0.07rem;
          right: 0.25rem;
          display: flex;
          z-index: 10;

          li {
            margin-left: 0.03rem;
            padding: 0.05rem 0.06rem;
            font-size: 0.12rem;
            color: #7b89dc;
            transition: all 0.3s;
            cursor: pointer;

            &:hover,
            &.active {
              color: #fff;
              background: #7b89dc;
              border-radius: 0.05rem;
            }
          }
        }

        &-chartArea {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
